export const formatDocument = (value) => {
  if (!value) return "";

  const numeric = value.replace(/\D/g, "");

  if (numeric.length === 14) {
    // Formata como CNPJ: 00.000.000/0000-00
    return numeric
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  if (numeric.length === 11) {
    // Formata como CPF: 000.000.000-00
    return numeric
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{2})$/, "$1-$2");
  }
  
  return value;
};
